import { phone } from 'fitify-ui-landing/src/theme/breakpoints'
import { motion } from 'framer-motion'
import styled, { css } from 'styled-components'

export const StyledAnimatedGroup = styled(motion.div)`
  position: relative;
  display: grid;
  border-radius: 25px;
  column-gap: 1rem;
  grid-auto-flow: column;

  ${phone(css`
    grid-auto-flow: row;
    justify-items: center;
    row-gap: 1rem;
  `)}
`
